import { useParams } from "react-router-dom";

export const principalsDetailinputs = principal => {
  const { name, secondName, type, archived, address } = principal;
  const { id } = useParams();

  return [
    {
      parentLabel: "",
      children: [
        {
          label: "Nom1",
          name: "name",
          value: name,
          required: true,
          capitalize: false,
          type: "input",
          col: 24,
        },
        {
          label: "Adresse",
          name: "address",
          value: address,
          type: "google-adress",
          col: 24,
        },
      ],
    },
    {
      children: [
        {
          label: id === "new" ? "Créer le mandant" : "Sauvegarder",
          name: "send",
          value: "send",
          type: "submit",
          col: 24,
          align: "right",
        },
      ],
    },
  ];
};
